import React, { useState } from 'react';
import {
  Container,
  Box,
  TextField,
  Button,
  Typography,
  Paper,
  Alert
} from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { useWebsiteAdminAuth } from '../../context/WebsiteAdminAuthContext';
import { fetchCurrentUser } from '../../../api/me';
import Layout from '../layout/Layout';

function parseSpecialAdmin(value) {
  if (value === true) return true;
  if (value === 'true') return true;
  return false;
}

const WebsiteAdminLogin = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const { adminLogin } = useWebsiteAdminAuth();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      const userCredential = await adminLogin(email, password);
      const user = userCredential.user;

      if (!user) {
        throw new Error('No user found after sign in');
      }

      const me = await fetchCurrentUser(await user.getIdToken());
      const isSpecialAdmin = parseSpecialAdmin(me?.user?.isSpecialAdmin ?? me?.isSpecialAdmin);
      if (!isSpecialAdmin) {
        setError('Access denied. You do not have website admin permissions.');
        setLoading(false);
        return;
      }

      navigate('/');
    } catch (error) {
      setError('Failed to sign in. Please check your credentials.');
      console.error('Login error:', error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Layout>
      <Container maxWidth="sm">
        <Box sx={{ mt: 8, mb: 4 }}>
          <Paper elevation={3} sx={{ p: 4, borderRadius: 2 }}>
            <Typography variant="h5" component="h1" gutterBottom align="center">
              Admin Login
            </Typography>

            {error && (
              <Alert severity="error" sx={{ mb: 2 }}>
                {error}
              </Alert>
            )}

            <Box component="form" onSubmit={handleSubmit}>
              <TextField
                margin="normal"
                required
                fullWidth
                id="email"
                label="Email Address"
                name="email"
                autoComplete="email"
                autoFocus
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
              <TextField
                margin="normal"
                required
                fullWidth
                name="password"
                label="Password"
                type="password"
                id="password"
                autoComplete="current-password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              />
              <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 0.5 }}>
                <Button
                  type="button"
                  size="small"
                  sx={{ textTransform: 'none', p: 0, minWidth: 0 }}
                  onClick={() => window.open('/app/forgot-password', '_blank')}
                >
                  Forgot password?
                </Button>
              </Box>
              <Button
                type="submit"
                fullWidth
                variant="contained"
                sx={{ mt: 3, mb: 2 }}
                disabled={loading}
              >
                {loading ? 'Signing in...' : 'Sign In'}
              </Button>
            </Box>
          </Paper>
        </Box>
      </Container>
    </Layout>
  );
};

export default WebsiteAdminLogin; 